Shopify.queryParams = {};

// Preserve existing query parameters
if (location.search.length) {
  var params = location.search.substr(1).split("&");

  for (var i = 0; i < params.length; i++) {
    var keyValue = params[i].split("=");

    if (keyValue.length) {
      Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(
        keyValue[1]
      );
    }
  }
}

// Update sort_by query parameter on select change
document.querySelector("#sort-by").addEventListener("change", function (e) {
  var value = e.target.value;

  Shopify.queryParams.sort_by = value;
  location.search = new URLSearchParams(Shopify.queryParams).toString();
});

const sortByInit = () => {
  const $sort_selection = document.getElementById("selected-sort-option");
  const $selected_option = document.querySelector(
    "#sort-by li:has(input:checked)"
  );
  const $selected_option_label = $selected_option.querySelector("label");
  const selected_option_name = $selected_option_label.textContent;
  $sort_selection.textContent = selected_option_name;
};

const checkLocation = async () => {
  const res = await fetch("https://ipapi.co/json/");
  const data = await res.json();

  console.log("Country:", data.country_code);
  const $products_price = document.querySelectorAll(".cp_price");
  $products_price.forEach($pp=>{
    if (data.country_code !== "EG") {
      $pp.classList.add("d-n");
    }
  })
};


 
sortByInit();
checkLocation();